export var SubscriptionRecurrenceInterval;
(function (SubscriptionRecurrenceInterval) {
    SubscriptionRecurrenceInterval["Monthly"] = "Monthly";
    SubscriptionRecurrenceInterval["Yearly"] = "Yearly";
})(SubscriptionRecurrenceInterval || (SubscriptionRecurrenceInterval = {}));
